export const BRAND = {
  name: "DADication",
  logo: "/dadication-logo.png",
  // Replace with the real donation page when ready
  donateUrl: "",
  email: "info@wearedadication.org",
  // Formspree endpoint for the contact form (works on any static host, no backend needed)
  formspreeEndpoint: "https://formspree.io/f/maqzzkwq",
  social: {
    instagram: "https://instagram.com/wearedadication",
    facebook: "https://facebook.com",
    twitter: "https://twitter.com",
  },
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1624272864537-8ecc72b67958?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxibGFjayUyMGZhdGhlciUyMHBsYXlpbmclMjB3aXRoJTIwY2hpbGQlMjBzdW5zZXR8ZW58MHx8fHwxNzgxNzM1NDM1fDA&ixlib=rb-4.1.0&q=85",
  community: "https://images.unsplash.com/photo-1758519288551-e22d8425d512?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0",
  mentorship: "https://plus.unsplash.com/premium_photo-1663126319781-f4de55c7ebd4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600&auto=format&fit=crop&ixlib=rb-4.1.0",
};
